
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {


    public getUsers(): any {
        return this.readFromSession("AFRICEREAL_USER_TO_AUTHENTIFICATION_SUPERADMIN");
    };
    public saveUsers(obj: any): void {
        // // //console.log("l'obejt",obj);

        this.saveToSession("AFRICEREAL_USER_TO_AUTHENTIFICATION_SUPERADMIN", obj);
    }

    //certificat de deces
    public getAdministrateur(): any {
        return this.readFromSession("AFRICEREAL_ADMINISTRATEUR");
    };
    public saveAdministrateur(obj: any): void {
        // // //console.log("l'obejt",obj);

        this.saveToSession("AFRICEREAL_ADMINISTRATEUR", obj);
    }
    public getMachine(): any {
        return this.readFromSession("AFRICEREAL_MACHINE");
    };
    public saveMachine(obj: any): void {
        // // //console.log("l'obejt",obj);

        this.saveToSession("AFRICEREAL_MACHINE", obj);
    }
    public getProduit(): any {
        return this.readFromSession("AFRICEREAL_PRODUITS");
    };
    public saveProduit(obj: any): void {
        // // //console.log("l'obejt",obj);

        this.saveToSession("AFRICEREAL_PRODUITS", obj);
    }
    public getUniteMesure(): any {
        return this.readFromSession("AFRICEREAL_UNITE_MESURE");
    };
    public saveUniteMesure(obj: any): void {
        // // //console.log("l'obejt",obj);

        this.saveToSession("AFRICEREAL_UNITE_MESURE", obj);
    }

    public getCooperative(): any {
        return this.readFromSession("AFRICEREAL_COOPERATIVE");
    };
    public saveCooperative(obj: any): void {
        // // //console.log("l'obejt",obj);

        this.saveToSession("AFRICEREAL_COOPERATIVE", obj);
    }


     public getCategorieMarket(): any {
        return this.readFromSession("AFRICEREAL_CATEGORIE_MARKET");
    };
    public saveCategorieMarke(obj: any): void {
        // // //console.log("l'obejt",obj);

        this.saveToSession("AFRICEREAL_CATEGORIE_MARKET", obj);
    }


    public getUserInfoToUpdatePassword(): any {
        return this.readFromSession("africereal");
    };
    public saveUserInfoToUpdatePassword(obj: any): void {
        // // //console.log("l'obejt",obj);
        this.saveToSession("africereal", obj);
    }
    //
    

    private readFromSession(key: string): any {
        let result = null;
        try {
            const json: any = localStorage.getItem(key);
            if (json) {
                const decoded = decodeURIComponent(escape(atob(json)));
                result = JSON.parse(decoded);
            }
        } catch (e) {
            //console.error("Error", e);
        }
        return result;
    }

    private saveToSession(key: string, value: any): void {

        //console.log("j'appelle le localstorage");

        try {
            const stringified = btoa(unescape(encodeURIComponent(JSON.stringify(value))));
            localStorage.setItem(key, stringified);

            //console.log("value",value);

        } catch (e) {
            //console.error("Error", e);
        }
    }


}